import { cn } from "@/lib/utils"

// The platform usage agreement every customer accepts (onboarding step two,
// /customer/terms), word for word. Also served read-only at
// /post-project/usage-agreement, which the guest account screen links to.
const PROSE =
  "text-[13.5px] leading-[1.65] text-muted-foreground [&_b]:font-semibold [&_b]:text-foreground [&_h4]:mt-4 [&_h4]:mb-1.5 [&_h4]:font-display [&_h4]:text-[13.5px] [&_h4]:font-bold [&_h4]:text-foreground [&_h4:first-child]:mt-0 [&_li]:my-1 [&_ol]:my-1.5 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:my-1.5 [&_ul]:my-1.5 [&_ul]:list-disc [&_ul]:pl-5"
const BOX = "max-h-[300px] overflow-y-auto rounded-[14px] border border-border bg-card px-[22px] py-5"

// `boxed`: in its own scrolling card, as the agreement step shows it.
export default function UsageAgreementText({ boxed = true }) {
  return (
    <div className={cn(PROSE, boxed && BOX)}>
      <h4>As a user of the platform, you agree to</h4>
      <ul>
        <li>
          Not share, or request, any personal information with, or from, our team. This includes requests, or
          sharing, of full name, email, country, address information, or any other request, or sharing, that may be
          deemed personal.
        </li>
        <li>Be respectful and keep conversations professional. Disrespect in any way will not be tolerated.</li>
        <li>Handle disputes with respect and request admin intervention if needed.</li>
      </ul>
      <h4>Indemnification for freelancer actions</h4>
      <p>
        Dibbly provides a platform that connects users with independent freelancers for content creation and other
        services. Freelancers are independent contractors and not employees, agents, or representatives of Dibbly.
        Dibbly makes no representations or warranties whatsoever with respect to Freelancers. By using the Dibbly
        platform, you agree to indemnify, defend, and hold harmless Dibbly, its affiliates, officers, directors,
        employees, and agents from and against any and all claims, liabilities, damages, losses, costs, expenses, and
        fees (including reasonable attorneys’ fees) arising out of or in connection with:
      </p>
      <ol>
        <li>Any actions, omissions, or negligence by freelancers engaged through the Dibbly platform.</li>
        <li>
          Any disputes, agreements, or dealings between you and any freelancer, including without limitation any
          claims related to intellectual property rights, restrictive covenants, work quality, deadlines, or breaches
          of contract.
        </li>
        <li>
          Any violation of applicable laws, regulations, or third-party rights by a freelancer, including, but not
          limited to, intellectual property rights, restrictive covenants and/or any contractual rights, while
          providing services through the Dibbly platform.
        </li>
      </ol>
      <p>
        This indemnification obligation will survive the termination or expiration of these Terms of Service and
        your use of the Dibbly platform.
      </p>
      <h4>Termination</h4>
      <p>
        <b>Dibbly | The Urban Writers may terminate access to the platform</b> should we find this agreement not
        adhered to or if we deem a scenario, not mentioned within this agreement, severe enough for termination.
      </p>
    </div>
  )
}
